import Box from "@mui/material/Box";
import React from "react";
import {
    convertFloatToPercentage,
    convertMinToDisplayFormat,
    convertNeedGuidanceToBatsuMark,
} from "../../../services/common/convert";
import * as settings from "../../../settings";
import { convertShiftDateToJpn } from "../../../utils/formatting";
import { ReserveTripsState } from "../store";
import { TripsTable } from "./Table";

interface Props {
    tripstate: ReserveTripsState;
    loading: boolean;
}

const NaviUsage: React.FC<Props> = (props: Props) => {
    if (props.tripstate.naviUsageRate === settings.naviUsageBlankVal) {
        return (
            <Box sx={{ display: "flex", alignSelf: "center" }}>ナビ利用率:</Box>
        );
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignSelf: "center" }}>
                ナビ利用率:{" "}
                {convertFloatToPercentage(props.tripstate.naviUsageRate)}
            </Box>
            <Box>
                {convertNeedGuidanceToBatsuMark(
                    props.tripstate.needGuidanceHermesHeader
                )}
            </Box>
        </Box>
    );
};

export const Header: React.FC<Props> = (props: Props) => {
    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: "flex" }}>
                <Box sx={{ p: 5 }}>
                    {convertShiftDateToJpn(props.tripstate.shiftDate)}
                </Box>
                <Box sx={{ p: 5 }}>
                    {props.tripstate.driverCode} {props.tripstate.driverName}
                </Box>
                <Box sx={{ p: 5 }}>
                    乗務時間:{" "}
                    {convertMinToDisplayFormat(
                        parseInt(props.tripstate.shiftMin, 10)
                    )}
                </Box>
                <NaviUsage {...props} />
            </Box>
        </Box>
    );
};

export const Container: React.FC<Props> = (props: Props) => {
    return (
        <Box
            id="Trips-Screen-wrapper"
            sx={{ position: "relative", left: "2px" }}
        >
            <Header {...props} />
            <Box>
                <TripsTable trips={props.tripstate.trips} />
            </Box>
        </Box>
    );
};
